module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-10-8355245561955165a146be0eea1c862b.svg";